/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderStatus {
    PRINT_PROOF_REVIEW = 'print_proof_review',
    FULFILLED = 'fulfilled',
    PENDING = 'pending',
}
